(function () {
  'use strict';
  document.cookie = 'sic_currency_lock=; Max-Age=0; path=/; SameSite=Lax';

  function syncAutomaticOfferMessaging() {
    var configNode = document.getElementById('SICWelcomeConfig');
    var words = {};
    try { words = JSON.parse(configNode.textContent).words || {}; } catch (_) {}
    var escapeText = function (value) { return String(value || '').replace(/[&<>"']/g, function (character) { return ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'})[character]; }); };
    var bar = document.querySelector('.sic-shipping-bar');
    if (bar) {
      bar.setAttribute('aria-label', 'First-order offer and shipping');
      bar.innerHTML = '<p style="margin:0">' +
        '<strong style="display:block;font-size:.95rem;font-weight:800;letter-spacing:.06em;line-height:1.25">' + escapeText(words.banner_title || '20% OFF YOUR FIRST ORDER') + '</strong>' +
        '<span style="display:block;margin-top:.22rem;font-size:.73rem;font-weight:650;letter-spacing:.015em;opacity:.96">' + escapeText(words.banner_detail || 'Applied automatically after you enter your email · No item limit') + '</span>' +
        '<span style="display:block;margin-top:.22rem;font-size:.73rem;font-weight:650;letter-spacing:.035em;opacity:.96">FREE STANDARD SHIPPING WORLDWIDE · DUTIES &amp; TAXES INCLUDED</span>' +
        '<span style="display:block;margin-top:.12rem;font-size:.68rem;letter-spacing:.015em;opacity:.82">Made to order · Dispatches in 5–7 business days · Tracked delivery</span>' +
        '</p>';
    }

    document.querySelectorAll('.sic-welcome-offer').forEach(function (el) {
      el.innerHTML = '<strong>20% off your first order · Applied automatically after you enter your email.</strong>';
      el.setAttribute('aria-label', '20% off your first order · Applied automatically after you enter your email.');
    });

    var popupSubhead = document.querySelector('#sic-popup-root .sic-subhead');
    if (popupSubhead) {
      popupSubhead.textContent = 'Your 20% first-order discount is applied automatically after you enter your email.';
    }

    document.querySelectorAll('.email-popup__sub--ps').forEach(function (el) {
      el.textContent = 'No sale blasts — we don’t run them. Just the letter, and 20% off your first order, applied automatically after you enter your email.';
    });

    var sticky = document.getElementById('sticky-tab');
    if (sticky) {
      sticky.setAttribute('aria-label', '20% off your first order · Applied automatically after you enter your email');
    }
  }

  syncAutomaticOfferMessaging();
})();

// ───── social footer channels ─────
(function () {
  'use strict';

  function addSocialFooterLinks() {
    var footer = document.querySelector('.footer-social');
    if (!footer) return;

    var links = [
      ['Instagram', 'https://www.instagram.com/souls.in.clothes/'],
      ['Facebook', 'https://www.facebook.com/1408131085706350'],
      ['Pinterest', 'https://www.pinterest.com/SoulsInClothes/'],
      ['Threads', 'https://www.threads.net/@souls.in.clothes'],
      ['TikTok', 'https://www.tiktok.com/@souls.in.clothes'],
      ['Bluesky', 'https://bsky.app/profile/soulsinclothes.bsky.social'],
      ['YouTube', 'https://www.youtube.com/channel/UCdBT4_Gtt-yKnU0Ohue3cvg']
    ];

    footer.innerHTML = '';

    links.forEach(function (item) {
      var a = document.createElement('a');
      a.href = item[1];
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.textContent = item[0];
      a.setAttribute('aria-label', item[0] + ' (opens in new tab)');
      footer.appendChild(a);
    });

    var wrap = footer.parentElement;
    var copy = wrap ? wrap.querySelector('.footer-copy') : null;
    if (wrap && copy && copy.previousElementSibling !== footer) {
      wrap.insertBefore(footer, copy);
    }

    var style = document.getElementById('sic-social-footer-layout');
    if (!style) {
      style = document.createElement('style');
      style.id = 'sic-social-footer-layout';
      document.head.appendChild(style);
    }

    style.textContent =
      '.footer-bottom{display:block!important;padding-top:10px!important;padding-bottom:38px!important;overflow:visible!important;}' +
      '.footer-social{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;width:min(100%,640px)!important;max-width:640px!important;margin:0 auto 16px!important;gap:9px 14px!important;align-items:center!important;overflow:visible!important;position:relative!important;top:-10px!important;}' +
      '.footer-social a{display:block!important;min-width:0!important;text-align:center!important;white-space:nowrap!important;font-size:12px!important;line-height:1.25!important;letter-spacing:0!important;overflow:visible!important;}' +
      '.footer-copy{text-align:center!important;margin:0!important;}' +
      '@media(max-width:749px){' +
        '.footer-bottom{padding:6px 8px 42px!important;}' +
        '.footer-social{grid-template-columns:repeat(4,minmax(0,1fr))!important;width:100%!important;max-width:none!important;gap:8px 2px!important;margin:0 auto 12px!important;top:-8px!important;}' +
        '.footer-social a{font-size:10px!important;line-height:1.2!important;padding:2px 0!important;}' +
      '}';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSocialFooterLinks);
  } else {
    addSocialFooterLinks();
  }
})();
